import { FunctionComponent } from 'react';
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import { TooltipItem, ChartType } from 'chart.js';

export type DonutChartProps = {
  AccountOverviewChartData: {
    labels: string[];
    datasets: [
      {
        label: string;
        backgroundColor: string[];
      },
    ];
  };
  handleDonutData: number[];
};

type FC = FunctionComponent<DonutChartProps>;

const Donut: FC = ({ AccountOverviewChartData, handleDonutData }: DonutChartProps) => {
  const data = {
    labels: AccountOverviewChartData.labels,
    datasets: [
      {
        label: AccountOverviewChartData.datasets[0].label,
        data: handleDonutData,
        backgroundColor: AccountOverviewChartData.datasets[0].backgroundColor,
        borderColor: 'transparent',
        borderRadius: 5,
        cutout: '50%',
        radius: '100%',
        circumference: 180,
        rotation: 270,
        hoverOffset: 6,
        responsive: true,
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 2,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label(context: TooltipItem<ChartType>) {
            const body = context.label || '';
            return body.toString();
          },
          afterLabel(context: TooltipItem<ChartType>) {
            const body = context.dataset.data[context.dataIndex] || '';
            return body.toLocaleString();
          },
        },
        padding: 10,
        titleAlign: 'center' as const,
        bodyAlign: 'center' as const,
        backgroundColor: '#FBFBFB',
        bodyColor: '#2D2D2D',
        displayColors: false,
        caretSize: 6,
        yAlign: 'top' as const,
        borderColor: 'none',
      },
    },
  };

  return <Doughnut data={data} options={chartOptions} />;
};

export default Donut;
